module.exports = __webpack_public_path__ + "static/render-63c730d00442541e9f3cf5f64cc10551.svg";